import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { routerMode } from '@/utils/index'
import Layout from '@/layout/index.vue'

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: routerMode == "hash" ? createWebHashHistory(import.meta.env.BASE_URL) : createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Layout,
      redirect: '/product/prepaid',
    },
    {
      path: '/product',
      name: 'product',
      component: Layout,
      redirect: '/product/prepaid',
      children: [
        {
          path: 'prepaid',
          name: 'productPrepaidList',
          component: () => import('@/views/product/prepaid.vue'),
        },
        {
          path: 'install',
          name: 'productInstall',
          component: () => import('@/views/product/install.vue'),
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: Layout,
      redirect: '/user/serviceInfo',
      children: [
        {
          path: 'api_keys',
          name: 'userApiKeys',
          component: () => import('@/views/user/apiKeys.vue'),
        },
        {
          path: 'serviceInfo',
          name: 'userServiceInfo',
          component: () => import('@/views/user/serviceInfo.vue'),
        }
      ]
    }
  ],
})

export default router
